import SEPlayApi from '../SEPlayApi';

export function updateImage({ orderId, imageReference, imagesArray }) {
    return SEPlayApi.updateImage(orderId, imageReference, imagesArray);
}
